export const getPermutiveIDs = () => {
  return {
    ORGANIZATION_ID: 'c64312a6-7872-45b9-86fd-6db73106f644',
    WORKSPACE_ID: 'c64312a6-7872-45b9-86fd-6db73106f644',
    WORKSPACE_PUBLIC_API_KEY: 'f193093e-0c47-41f7-8a1d-5ce9671a8145',
  }
}
